module.exports = __webpack_public_path__ + "static/img/LVT.931b1c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vubrostand/LVT/LVT.png
// module id = GViM
// module chunks = 0